import { Injectable } from '@angular/core';

import { AjaxService } from './ajax.service';
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators'
import { AlertsOuter } from 'src/app/landing/alerts/alerts.interface';
@Injectable({
  providedIn: 'root'
})
export class CommonDataService {

  userDetails: any;
  userDetailsObservable: any;
  summary: any;
  summmaryObservable: any;
  _role: any;
  _isLoading: boolean = false;
  _activeCasesCount: number = 0;
  _alerts: AlertsOuter[] = [];
  _totalCasesCount: number = 0;
  _hasNewAlert: boolean = false;
  _isApporver: boolean = false;
  _approverLevel: any;
  constructor(private _ajaxService: AjaxService
  ) { }

  getUserDetails(): Observable<any> {
    if (this.userDetails) {
      return of(this.userDetails)
    } else if (this.userDetailsObservable) {
      return this.userDetailsObservable;
    } else {
      this.userDetailsObservable = this._ajaxService.get('/users/userDetails').pipe(
        retry(1),
        catchError(val => of({ error: val, success: false })),
        map(response => {
          if (response.success) {
            this.userDetailsObservable = null;
            this.isApprover = response.data.IsApprover;
            this.approveLevel = response.data.ApproverLevel;
            this.userDetails = response;
            let role = response.data.Role;
            this.role = role;
          }
          return response;
        }));
      return this.userDetailsObservable;
    }
  }

  handleError(error: any) {
    console.log('Error ' + error);
  }

  getSummary(): Observable<any> {
    return this._ajaxService.get('/users/getSummary').pipe(
      map(response => {
        this.summmaryObservable = null;
        this.summary = response;
        return response;
      }));
  }

  get isApprover() {
    return this._isApporver;
  }

  set isApprover(approve: boolean) {
    this._isApporver = approve;
  }

  get approveLevel() {
    return this._approverLevel;
  }

  set approveLevel(approveLevel: any) {
    this._approverLevel = approveLevel;
  }

  get role() {
    return this._role;
  }

  set role(role: string) {
    this._role = role;
  }

  get isLoading() {
    return this._isLoading;
  }

  set isLoading(loading: boolean) {
    this._isLoading = loading;
  }

  get activeCasesCount() {
    return this._activeCasesCount;
  }

  set activeCasesCount(activeCasesCount: number) {
    this._activeCasesCount = activeCasesCount;
  }

  get alerts() {
    return this._alerts;
  }

  set alerts(alerts: AlertsOuter[]) {
    this._alerts = alerts;
  }

  get totalCasesCount() {
    return this._totalCasesCount;
  }

  set totalCasesCount(totalCasesCount: number) {
    this._totalCasesCount = totalCasesCount;
  }

  get hasNewAlert() {
    return this._hasNewAlert;
  }

  set hasNewAlert(newAlert: boolean) {
    this._hasNewAlert = newAlert;
  }

}
